export default __webpack_public_path__ + "static/feature-banner-right-credit-card-0c95c7272142a22c6b8cf73a955ca112.jpg";